import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EwebinarRegular from './ewebinar-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EwebinarRegular {...validProps} />;
}
SvgComponent.iconName = 'eWebinarRegular';

export const EWebinarRegularIcon = svgIconWrapper(SvgComponent);
